import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-select-account-modal',
  templateUrl: './select-account-modal.component.html',
  styleUrls: [
    './select-account-modal.component.scss',
    '../../../../../fragments/modal/modal.fragment.scss'
  ]
})
export class SelectAccountModalComponent implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  public formGroup: FormGroup;
  public emails: Array<string> = [];

  @Output() public closeEmitter = new EventEmitter<string | undefined>();

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
        this.closeModal();
    }
  }

  constructor(
    private _formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.formGroup = this._formBuilder.group({
      email: ['', [Validators.required]]
    });
  }

  public selectAccount(): void {
    const email = this.formGroup.get('email').value;
    this.closeModal(email && email !== '' ? email : undefined);
  }

  public closeModal(res?: string): void {
    this.closeEmitter.emit(res);
  }

}
